<template>
    <div class="row justify-content-center g-4">
        <div v-for="(item, index) in blogData" :key="index" class="col-xl-4 col-lg-4 col-md-6">
            <div class="blog-wrap-grid h-100 shadow">
                <div class="blog-thumb">
                    <router-link v-if="localizedBlogPath(item)"
                        :to="localizedBlogPath(item)"><img :src="item.image" class="img-fluid" alt="blog-image" /></router-link>
                </div>
                <div class="blog-body">
                    <h4 class="bl-title"><router-link v-if="localizedBlogPath(item)"
                        :to="localizedBlogPath(item)">{{item.title}}</router-link></h4>
                    <p>{{ truncateText(item.short_description, 10) }}</p>
                    <router-link v-if="localizedBlogPath(item)"
                        :to="localizedBlogPath(item)" class="post-date label bg-seegreen text-light "><i class="ti ti-calendar px-1"></i>{{$t('Continue')}}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { ref, watch } from "vue";
import axios from "axios";

const { locale } = useI18n();
const blogData = ref([]);
const loading = ref(false);
const localizedBlogPath = (item) => {
  const currentSlug = item.slug?.[locale.value]

  if (!currentSlug) return null  

  return `/${locale.value}/blog-detail/${currentSlug}`
}
const fetchBlogs = async () => {
    loading.value = true;
    try {
        const response = await axios.get(`/blogs?limit=3&lang=${locale.value}&sort=latest`);  
        blogData.value = response.data.data;
    } catch (error) {
        console.error("Error fetching blogs:", error);
    } finally {
        loading.value = false;
    }
};

watch(locale, fetchBlogs, { immediate: true });

const truncateText = (text, wordLimit) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + "..." : text;
};
</script>